import { combineReducers } from 'redux';
import { createReducer } from 'typesafe-actions';
import { normalizeNoteEntityResponse, normalizeNoteListResponse } from 'lib/normalization';
import { Note } from 'types/dto';
import { RequestStatus } from 'types/transport';
import { NoteAction } from './actions';

const entitiesReducer = createReducer<Array<Note>>([])
  .handleType(NoteAction.Clear, () => [])
  .handleType(NoteAction.ListResponse, (state, action) => normalizeNoteListResponse(action.payload))
  .handleType(NoteAction.Response, (state, action) => [
    ...state,
    normalizeNoteEntityResponse(action.payload),
  ]);

const statusReducer = createReducer<RequestStatus>(RequestStatus.None)
  .handleType(NoteAction.Clear, () => RequestStatus.None)
  .handleType(NoteAction.CreateRequest, () => RequestStatus.Creating)
  .handleType(NoteAction.CreateResponse, () => RequestStatus.Success)
  .handleType(NoteAction.Error, () => RequestStatus.Error)
  .handleType(NoteAction.ListRequest, () => RequestStatus.Reading)
  .handleType(NoteAction.ListResponse, () => RequestStatus.Success)
  .handleType(NoteAction.Request, () => RequestStatus.Reading)
  .handleType(NoteAction.Response, () => RequestStatus.Success);

export default combineReducers({
  entities: entitiesReducer,
  status: statusReducer,
});
